var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRedesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "645.6 -11 256 256",
    enableBackground: "new 645.6 -11 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M697.2,168.7c-25.8-19.1-39.8-50.4-36.8-82.3c2.2-22.8,12.7-43.8,29.7-59.2c16.9-15.3,38.7-23.7,61.3-23.7 c2.9,0,5.8,0.1,8.7,0.4c37.9,3.6,68.3,30,78.9,64.4c4.2-4.3,8.2-8.3,11.6-11.8c-4.1-10.4-9.9-20.3-17.2-29.2 c-18.1-21.9-43.7-35.5-71.9-38.2c-3.4-0.3-6.8-0.5-10.1-0.5c-26.3,0-51.6,9.8-71.3,27.6C660.5,34,648.2,58.5,645.7,85 c-3.4,35.9,11.2,70.4,39.3,92.9l-28.4-2.7l-1.4,14.8l54.5,5.2l4.7-49.5l-14.8-1.4L697.2,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.6,59.5L742.2,185l-16.5,49.1l49.4-16.3L901.6,92.2L868.6,59.5z M766.9,204.6l-17.3,5.7l5.8-17.2 l4.5-4.5l11.6,11.5L766.9,204.6z M782.2,189.5L770.7,178l75.7-75.2l11.6,11.5L782.2,189.5z M857.1,92.2l11.5-11.5l11.5,11.5 l-11.5,11.5L857.1,92.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedesign);
export default __webpack_public_path__ + "static/media/icon-redesign.80b122a7.svg";
export { ForwardRef as ReactComponent };